import React, {useEffect, useState} from 'react';
import {connect} from "react-redux";

import {showToastForBackend, showToastForFrontend} from "../../../../../actions/toastActions";
import axios from "axios";
import axiosConfig from "../../../../../utils/axiosConfig";
import messageCodes from "../../../../../utils/messageCodes";
import possibleFunctions from "../../possibleFunctions";
import {FunctionModifier} from "../../InputPortListUtils/components/FunctionModifier";
import FieldModifierSubQuery from "./components/FieldModifierSubQuery";
import FieldModifierValue from "./components/FieldModifierValue";
import {AddNewOptionsButtonGroup} from "../../InputPortListUtils/components/AddNewOptionsButtonGroup";

const FieldModifier = (props) => {
    const {modifier, properties} = props;
    const [state, setState] = useState({
        func: modifier,
        itemProperties: props.itemProperties ? props.itemProperties : [],
        userProperties: props.userProperties ? props.userProperties : [],
    });

    const funcArgs = state?.func?.funcArgs;

    const isGroup = (argument) => {
        return Object.keys(possibleFunctions).includes(argument.funcName);
    }

    const getItemUserProperties =  () => {
        const itemProperties = state.itemProperties;

        if (itemProperties.length === 0) {
             axios.get(props.properties.databaseUrl + "/properties/items", axiosConfig())
                .then(response => {
                    setState({
                        ...state,
                        itemProperties: response.data
                    });
                })
                .catch(err => {
                    if (err.response)
                        props.showToastForBackend(err.response.data);
                    else
                        props.showToastForFrontend(messageCodes.CONNECTION_ERROR);
                });
        }

        const userProperties = state.userProperties;
        if (userProperties.length === 0) {
             axios.get(props.properties.databaseUrl + "/properties/users", axiosConfig())
                .then(response => {
                    setState({
                        ...state,
                        userProperties: response.data
                    });
                })
                .catch(err => {
                    if (err.response) {
                        props.showToastForBackend(err.response.data);
                    }
                    else {
                        props.showToastForFrontend(messageCodes.CONNECTION_ERROR);
                    }
                });
        }
    }

    useEffect(() => {
        props.updateOptions(state.func)
    }, [state.func])

    useEffect(() => {
        if (properties) {
            getItemUserProperties();
        }
    }, [properties]);

    const onArgumentOptionUpdate = (index, argumentData) => {
        let fieldModifier = {...state.func};
        fieldModifier.funcArgs[index] = argumentData;

        setState({
            ...state,
            func: {
                ...fieldModifier
            }
        });
    }

    const onArgumentDelete = (index) => {
        const func = {...state.func};
        func.funcArgs = func.funcArgs.filter((value, funcArgIndex) => funcArgIndex !== index);

        setState({
            ...state,
            func: {
                ...func
            }
        });
    }

    const handleToggleModifier = (modifierFunctionKey) => {
        const funcName = modifierFunctionKey;
        setState(prevState => ({
                ...prevState,
                func: {
                    ...prevState.func,
                    funcName
                }
            }
        ))
    }

    return (
        <div className="field-modifier-group">
            <div className="field-modifier-group-content">
                <div className="predicate-panel field-modifier-panel">
                    <div className="predicate-group-header-wrapper field-modifier-header">
                        <FunctionModifier state={state} handleToggleModifier={handleToggleModifier}/>
                        <div className="main-and predicate-group and">
                            {funcArgs?.map((argument, index) => {
                                if (isGroup(argument)) {
                                    return (
                                        <FieldModifierSubQuery
                                            key={index + "subquery"}
                                            disableArea={props.disableArea}
                                            defaultPredicateValue={props.defaultPredicateValue}
                                            userProperties={state.userProperties}
                                            itemProperties={state.itemProperties}
                                            contextProperties={props.contextProps}
                                            predicateBlockType={props.predicateBlockType}
                                            argument={argument}
                                            onArgumentOptionUpdate={(data => onArgumentOptionUpdate(index, data))}
                                            onArgumentDelete={() => onArgumentDelete(index)}
                                            elementIdAutoIncrement={modifier.elementIdAutoIncrement}
                                            updateProperty={props.updateProperty}
                                            possibleFunctions={possibleFunctions}
                                        />
                                    )
                                } else {
                                    return <FieldModifierValue
                                        key={index + "value"}
                                        disableArea={props.disableArea}
                                        {...argument}
                                        userProperties={state.userProperties}
                                        itemProperties={state.itemProperties}
                                        contextProperties={props.contextProps}
                                        predicateBlockType={props.predicateBlockType}
                                        onArgumentOptionUpdate={(data) => onArgumentOptionUpdate(index, data)}
                                        onArgumentDelete={() => onArgumentDelete(index)}
                                    />
                                }
                            })}
                        </div>
                        <AddNewOptionsButtonGroup state={state}
                                                  setState={setState}
                                                  updateOptions={props.updateOptions}
                                                  updateProperty={props.updateProperty}
                                                  elementIdAutoIncrement={props.elementIdAutoIncrement}/>
                    </div>
                </div>
            </div>
        </div>
    );
}

function mapStateToProps(state) {
    return {
        properties: state.properties,
        contextProps: state.contextProperties,
        itemProperties: state.itemProperties,
        userProperties: state.userProperties
    }
}

export default connect(mapStateToProps, {showToastForFrontend, showToastForBackend})(FieldModifier);